var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TableView',{attrs:{"col":_vm.columns,"getData":_vm.getData}}),_c('b-modal',{ref:"view-deal-out",attrs:{"title":'View Deal',"size":"xl","hide-footer":""}},[_c('AddDealForm',{attrs:{"rows":_vm.rowData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }